import React, { useEffect, useState } from "react";
import "./AdminPanel.css";
import { useNavigate } from "react-router-dom";

function AdminPanel() {
  const [admin, setAdmin] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
  fetch("https://68a70e05639c6a54e9a0d108.mockapi.io/adminlogin")
    .then((res) => res.json())
    .then((data) => setAdmin(data))
    .catch((err) => console.error("Error fetching admin:", err));
}, []);

  return (
    <div className="admin-panel-container">
      {/* Header */}
      <div className="admin-panel-header">
        <img src="/logo.png" alt="FlyTutor Logo" className="admin-logo" />
        <a href="/" className="navbar-link">Home</a>
        <h2>Admin Panel</h2>
      </div>

      {/* Main Card */}
      <div className="admin-panel-card">
        <div className="admin-panel-content">
          <p>
            <span role="img" aria-label="user">👤</span> Admin Name :{" "}
            <span style={{ color: "purple", fontWeight: "bold" }}>
              {admin.name || "Loading..."}
            </span>
          </p>

          {/* Buttons */}
          <div className="admin-panel-buttons">
            <button className="admin-btn" onClick={() => navigate("/admin-courses")}>
              Course
            </button>
            <button className="admin-btn" onClick={() => navigate("/admin-certificates")}>
              Certificate
            </button>
            <button className="admin-btn" onClick={() => navigate("/admin-about")}>
              About
            </button>
            <button className="admin-btn" onClick={() => navigate("/admin-contact")}>
              Contact
            </button>
          </div>
        </div>

        {/* Logo */}
        <img src="/logo.png" alt="FlyTutor Logo" className="flytutor-logo-large" />
      </div>
    </div>
  );
}

export default AdminPanel;
